
import { getApiVersion } from './config.js'
import { makeGetRequest, makePostRequest } from './util.js'

const RELATIVE_PREFIX = 'active_sync'

function getScheduleRequestAllData(id, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.status) filteredQueryParams.status = queryParams.status
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/schedule_request_all_data/${id}`, filteredQueryParams)
}

function postScheduleRequestStatusUpdate(id, body) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/schedule_request_status_update/${id}`, body)
}

function postSetRoutePullScheduleRequest(scheduleRequestId, body) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/set_route_pull/schedule_request/${scheduleRequestId}`, body)
}

function postRoutePullEntry(body) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/route_pull/entry`, body)
}

function getRoutePullEntry(queryParams) {
  // var filteredQueryParams = {}
  // if (queryParams?.options) filteredQueryParams.options = queryParams.options

  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/route_pull/entry`, queryParams)
}

function getRoutePullData(taskId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.length) filteredQueryParams.length = queryParams.length
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/route_pull/data/${taskId}`, filteredQueryParams)
}

function getRoutePullList() {
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/route_pull`)
}

function getScheduleRequestsControlPanel(queryParams) {
  var filteredQueryParams = {}
  if (queryParams.createdAtStart) filteredQueryParams.created_at_start = queryParams.createdAtStart
  if (queryParams.createdAtEnd) filteredQueryParams.created_at_end = queryParams.createdAtEnd
  if (queryParams.studentFilter) filteredQueryParams.student = queryParams.studentFilter
  if (queryParams.onlyIncomplete) filteredQueryParams.only_incomplete = queryParams.onlyIncomplete
  if (queryParams.onlyError) filteredQueryParams.only_errors = queryParams.onlyError
  if (queryParams.orderBy) filteredQueryParams.order_by = queryParams.orderBy
  if (queryParams.page) filteredQueryParams.page = queryParams.page

  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/sr_control_panel`, filteredQueryParams)
}

function getStudentRequestsControlPanelData(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.ids) filteredQueryParams.id = queryParams.ids
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/sr_control_panel/data`, filteredQueryParams)
}

function postStudentRequestsControlPanelRunTask(action, scheduleRequestId) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/sr_control_panel/run_task/${action}/${scheduleRequestId}`)
}

function getStudentRequestsControlPanelErrorLog(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.errorIds) filteredQueryParams.id = queryParams.errorIds
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/sr_control_panel/error_log`, filteredQueryParams)
}

function getTransferDate(queryParams) {
  var filteredQueryParams = {}
  if (queryParams.createdAtStart) filteredQueryParams.created_at_start = queryParams.createdAtStart
  if (queryParams.createdAtEnd) filteredQueryParams.created_at_end = queryParams.createdAtEnd
  if (queryParams.transferStart) filteredQueryParams.transfer_start = queryParams.transferStart
  if (queryParams.transferEnd) filteredQueryParams.transfer_end = queryParams.transferEnd
  if (queryParams.studentFilter) filteredQueryParams.student = queryParams.studentFilter
  if (queryParams.partitionFilter) filteredQueryParams.partition = queryParams.partitionFilter
  if (queryParams.orderBy) filteredQueryParams.order_by = queryParams.orderBy
  if (queryParams.page) filteredQueryParams.page = queryParams.page

  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/transfer_date`, filteredQueryParams)
}

function postTransferDateDelete(body) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/transfer_date/delete`, body)
}

export {
  getScheduleRequestAllData,
  postScheduleRequestStatusUpdate,
  postSetRoutePullScheduleRequest,
  postRoutePullEntry,
  getRoutePullEntry,
  getRoutePullData,
  getRoutePullList,
  getScheduleRequestsControlPanel,
  getStudentRequestsControlPanelData,
  postStudentRequestsControlPanelRunTask,
  getStudentRequestsControlPanelErrorLog,
  getTransferDate,
  postTransferDateDelete,
}
